export const RENTAL_MANAGER_API_V1_PREFIX = 'rental-manager-api/api/v1';
export const RENTAL_MANAGER_API_V2_PREFIX = 'rental-manager-api/api/v2';
export const INVOICE_PAYMENTS = 'invoicepayments';
